import gsap from "gsap";

class Loader {
	constructor() {
		this.DOM = document.querySelector(".loader");

		const { host } = window.location;

		if (this.DOM) {
			// if (host == "localhost:3000" || host == "dev.babled.fr") {
			// 	this.stop();
			// } else {
			// 	this.init();
			// }
			this.init();
		}
	}
	init() {
		const tl = gsap.timeline();
		const bck = this.DOM.querySelector(".bck");
		const SVG = this.DOM.querySelector(".svg");
		const pathAndG = [...this.DOM.querySelectorAll("path, g")];
		const chs = [];
		const tba = [
			this.DOM.querySelector("#thibaud #t_ch"),
			this.DOM.querySelector("#babled #b_ch"),
			this.DOM.querySelector("#architectures #a_ch"),
		];

		pathAndG.forEach((ch) => {
			const chId = ch.id;
			if (chId && chId.includes("_ch")) {
				chs.push(ch);
			}
		});

		// START LETTERS
		tl.to(SVG, { opacity: 1, duration: 0.2 });
		tl.to(chs, { opacity: 0, duration: 0.2 });
		tl.fromTo(
			chs,
			{
				opacity: 0,
				y: -5,
			},
			{
				opacity: 1,
				y: 0,
				duration: 0.6,
				stagger: {
					amount: 1.6,
					ease: "power1.in",
				},
			}
		);
		// ONLY TBA
		tl.to(chs, { opacity: 1, duration: 0.5 });
		tl.to(chs, {
			opacity: 0,
			duration: 1.5,
		});
		tl.to(
			tba,
			{
				opacity: 1,
				duration: 1.5,
			},
			"<"
		);

		// POSTION TBA
		tl.to(tba, { opacity: 1, duration: 0.5 });
		tl.add(() => {
			tba[1].classList.add("tba-1");
			tba[2].classList.add("tba-2");
		});

		// TOP
		tl.to(tba, { opacity: 1, duration: 1 });
		tl.fromTo(
			SVG,
			{
				top: "50%",
			},
			// { top: "2.65rem", duration: 0.5 }
			{ top: "2.8rem", duration: 0.5 }
		);
		tl.add(() => {
			SVG.classList.add("base");
		}, "<");

		// BACKGROUND
		tl.to(bck, { opacity: 0, duration: 0.5 });
		tl.to(tba, { opacity: 0, duration: 0.25 });

		// END
		tl.to(this.DOM, { autoAlpha: 0, duration: 0.1 });

		// SET COOKIE
		tl.add(() => {
			setCookie("intro", true, 10); // TODO: A remettre !
		});
	}
	stop() {
		this.DOM.remove();
	}
}

export default new Loader();

function setCookie(name, value, minutes) {
	var expires = "";
	if (minutes) {
		var date = new Date();
		date.setTime(date.getTime() + minutes * 60 * 1000);
		var expires = "; expires=" + date.toGMTString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == " ") c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}
function eraseCookie(name) {
	document.cookie = name + "=; Max-Age=-99999999;";
}
